interface DynamicConfig {
  /** Base URL of wio.suitability.api. */
  suitabilityApiUrl: string;
  /** Base URL of wio.api (used for shared catalog data like /risks). */
  wioApiUrl: string;
  /** Base URL of wio.pdf (genera los PDF de los informes; p.ej. test de idoneidad). */
  wioPdfUrl: string;
  /**
   * Origin of the parent app (wio.front) allowed to embed this app and relay
   * the auth token via postMessage. Used to validate the message source/origin.
   */
  parentOrigin: string;
  environment: 'development' | 'test' | 'production' | 'staging' | string;
  baseHref: string;
}

const defaultConfig: DynamicConfig = {
  suitabilityApiUrl: process.env.SUITABILITY_API_URL || '',
  wioApiUrl: process.env.WIO_API_URL || '',
  wioPdfUrl: process.env.WIO_PDF_URL || '',
  parentOrigin: process.env.PARENT_ORIGIN || '',
  environment: process.env.ENV_NAME || '',
  baseHref: process.env.BASE_HREF || '',
};

class GlobalConfig {
  config: DynamicConfig = defaultConfig;
}

export const globalConfig = new GlobalConfig();

export const globalConfigUrl = 'config.json';
